import { Link, useLocation } from 'react-router-dom';

import { themeStore } from 'Models/ThemeStore';
import LoginFlow from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/LoginStep/LoginFlow';
import { RegisterLocationState } from 'Models/_HumanWritten/LocationState';
import useDeviceDetect from 'Hooks/useDeviceDetect';

export default function RegisterPage() {
	const location = useLocation();
	const state = location.state as RegisterLocationState;
	const { isMobile } = useDeviceDetect();

	return (
		<div className="login-page">
			<Link className="logo-link" to="/home">
				<img
					src={isMobile ? themeStore.logoSecondaryLightURL : themeStore.logoPrimaryLightURL}
					alt="Company Logo"
				/>
			</Link>
			<div
				className="top-section"
				style={{
					backgroundImage: `url(${themeStore.loginBackgroundImageURL})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
				}}
			/>
			<div className="bottom-section" />
			<div className="center-section">
				<LoginFlow mode="registrationOnly" initialParams={state} />
			</div>
		</div>
	);
}
